import { render } from "./AddCustomerPage.vue?vue&type=template&id=1738e366&scoped=true"
import script from "./AddCustomerPage.vue?vue&type=script&lang=js"
export * from "./AddCustomerPage.vue?vue&type=script&lang=js"

import "./AddCustomerPage.vue?vue&type=style&index=0&id=1738e366&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1738e366"]])

export default __exports__